import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getTeamsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/teams");

  return response.data;
};
